import { redirect } from '@tanstack/react-router';
import { featureFlagsService } from '@/features/branding/services/feature-flags.service';

export async function requireFeature(featureKey: string, redirectTo = '/my-dashboard') {
  const flags = await featureFlagsService.listMy();
  const enabled = flags.find((f) => f.featureKey === featureKey)?.isEnabled;
  if (!enabled) {
    throw redirect({ to: redirectTo });
  }
}

export async function requireAnyFeature(
  featureKeys: string[],
  redirectTo = '/my-dashboard',
) {
  const flags = await featureFlagsService.listMy();
  const enabled = featureKeys.some((key) =>
    flags.find((f) => f.featureKey === key)?.isEnabled,
  );
  if (!enabled) {
    throw redirect({ to: redirectTo });
  }
}
